import type { Board, Cell, Grid } from './types';

/** 行数（缺省 = n，方形） */
export const rowsOf = (board: Board): number => board.rows ?? board.n;
export const gridOf = (board: Board): Grid => ({ cols: board.n, rows: rowsOf(board) });
/** 块数 = 列 × 行 */
export const tileCount = (board: Board): number => board.n * rowsOf(board);
/** 只有长方形棋盘才写 rows（方形棋盘的对象 / 存档与以前逐字节相同） */
export const rowsField = (cols: number, rows: number): { rows?: number } => (rows === cols ? {} : { rows });

export const homeOf = (tile: number, n: number): Cell => ({ row: Math.floor(tile / n), col: tile % n });
export const cellIndex = (c: Cell, n: number): number => c.row * n + c.col;
export const sameCell = (a: Cell, b: Cell): boolean => a.row === b.row && a.col === b.col;

export function solvedBoard(n: number, rows = n): Board {
  return { n, ...rowsField(n, rows), pos: Array.from({ length: n * rows }, (_, t) => homeOf(t, n)) };
}

/** 下标为格子序号（row*n+col），值为占据它的 tileId */
export function occupants(board: Board): number[] {
  const out = new Array<number>(tileCount(board));
  board.pos.forEach((c, tile) => {
    out[cellIndex(c, board.n)] = tile;
  });
  return out;
}

/** 这块能参与粘连吗：正面朝上且没转（rot = 0） */
export const isUpright = (board: Board, tile: number): boolean => !(board.rot?.[tile]) && !board.down?.[tile];

/** 全部在原位，且全部转正、翻开 */
export function isSolved(board: Board): boolean {
  return board.pos.every((c, t) => sameCell(c, homeOf(t, board.n)) && isUpright(board, t));
}

/** cells[row][col] = tileId */
export function boardFromCells(cells: number[][]): Board {
  const rows = cells.length;
  const n = cells[0]?.length ?? 0;
  const pos: Cell[] = new Array(n * rows);
  cells.forEach((rowTiles, row) => rowTiles.forEach((tile, col) => (pos[tile] = { row, col })));
  return { n, ...rowsField(n, rows), pos };
}

export function cellsOf(board: Board): number[][] {
  const occ = occupants(board);
  return Array.from({ length: rowsOf(board) }, (_, r) => occ.slice(r * board.n, (r + 1) * board.n));
}
